/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import Select, { SingleValue } from 'react-select';

import { IDropdownItemProps, IDropdownOnSelectionChangeNotification, IDropdownProps } from './dropdown.props';

interface ISelectOption {
    value: string;
    label: string;
    isDisabled?: boolean;
}

export class DropdownWithSearch extends React.PureComponent<IDropdownProps> {
    public render(): JSX.Element {
        const { dropdownId, dropdownName, dropdownList, dropdownToggleName, selectedId } = this.props;

        const options: ISelectOption[] = dropdownList.map((item: IDropdownItemProps) => ({
            value: item.id,
            label: item.value,
            isDisabled: item.isDisabled
        }));

        const selectedOption = options.find(option => option.value === selectedId) ?? null;

        return (
            <Select
                inputId={`msc-dropdown__select__entry-${dropdownId}`}
                instanceId={`msc-dropdown__select__instance-${dropdownId}`}
                className='msc-dropdown__select'
                classNamePrefix='msc-dropdown__select'
                aria-label={dropdownName}
                options={options}
                value={selectedOption}
                onChange={this._onChange}
                isSearchable={true}
                isClearable={false}
                placeholder={dropdownToggleName}
            />
        );
    }

    private readonly _onChange = async (option: SingleValue<ISelectOption>) => {
        if (!option || !this.props.onChange) {
            return;
        }

        const notification: IDropdownOnSelectionChangeNotification = {
            dropdownId: this.props.dropdownId,
            selectId: option.value,
            selectedValue: option.label
        };

        await this.props.onChange(notification);
    };
}

export default DropdownWithSearch;
